export default __webpack_public_path__ + "static/media/icono-reportar-cortado.8b6b4a2e.svg";